import React from 'react';
import { BookingProvider } from './components/BookingContext';
import { BookingExperience } from './components/BookingExperience';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { LiveAgentStrip } from './components/LiveAgentStrip';
import { ValueProp } from './components/ValueProp';
import { VerticalSolutions } from './components/VerticalSolutions';
import { AgentDemo } from './components/AgentDemo';
import { HowItWorks } from './components/HowItWorks';
import { DeploymentSection } from './components/DeploymentSection';
import { BeforeAfter } from './components/BeforeAfter';
import { TrustSection } from './components/TrustSection';
import { SocialProof } from './components/SocialProof';
import { AboutSection } from './components/AboutSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { AmbientBackground } from './components/AmbientBackground';
import { SectionDivider } from './components/SectionDivider';
import { QuietConfidence } from './components/QuietConfidence';
export function App() {
  return <BookingProvider data-id="element-0">
      <div className="relative min-h-screen bg-brand-black text-white selection:bg-brand-orange/30" data-id="element-1">
        <AmbientBackground data-id="element-2" />
        <Navbar data-id="element-3" />
        <main className="relative z-10" data-id="element-4">
          <HeroSection data-id="element-5" />
          <LiveAgentStrip data-id="element-6" />
          <SectionDivider data-id="element-7" />
          <ValueProp data-id="element-8" />
          <QuietConfidence text="Not built for demos. Built for operations." data-id="element-9" />
          <VerticalSolutions data-id="element-10" />
          <SectionDivider data-id="element-11" />
          <AgentDemo data-id="element-12" />
          <QuietConfidence text="Where reasoning meets execution." data-id="element-13" />
          <HowItWorks data-id="element-14" />
          <SectionDivider data-id="element-15" />
          <DeploymentSection data-id="element-16" />
          <QuietConfidence text="Context is everything." data-id="element-17" />
          <BeforeAfter data-id="element-18" />
          <SectionDivider data-id="element-19" />
          <TrustSection data-id="element-20" />
          <SectionDivider data-id="element-21" />
          <SocialProof data-id="element-22" />
          <SectionDivider data-id="element-23" />
          <AboutSection data-id="element-24" />
          <SectionDivider data-id="element-25" />
          <CTASection data-id="element-26" />
        </main>
        <Footer data-id="element-27" />
        <BookingExperience data-id="element-28" />
      </div>
    </BookingProvider>;
}